import { useOverlayRef } from '@aigc/overlay-hook';
import { Image } from 'antd';
import type { PreviewConfig } from 'antd/es/image';
import { useState } from 'react';

export type ImagePreviewProps = Omit<
  PreviewConfig,
  'open' | 'afterOpenChange' | 'onOpenChange'
>;

export const MediaPreview = (props: ImagePreviewProps) => {
  const [open, onOpenChange] = useState(true);
  const overlayRef = useOverlayRef();

  return (
    <Image
      styles={{ root: { display: 'none' } }}
      preview={{
        open,
        onOpenChange: onOpenChange,
        afterOpenChange: (afterOpen) => {
          if (!afterOpen) {
            overlayRef.close();
          }
        },
        imageRender: (node, info) => {
          if (!URL.canParse(info.image.url)) {
            return node;
          }

          const url = new URL(info.image.url);

          if (url.pathname.endsWith('.mp4')) {
            return (
              <video
                src={info.image.url}
                style={{ maxHeight: '75%' }}
                controls
                muted
                autoPlay
              ></video>
            );
          }

          if (url.pathname.endsWith('mp3')) {
            return <audio src={url.toString()} controls></audio>;
          }

          return node;
        },
        ...props,
      }}
    ></Image>
  );
};
